import React from 'react'

const ImportSound = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
            <mask height="24" id="mask0_281_82" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="24" x="1" y="1">
                <path d="M13 23.8334C7.01675 23.8334 2.16666 18.9833 2.16666 13C2.16666 7.01677 7.01675 2.16669 13 2.16669C18.9832 2.16669 23.8333 7.01677 23.8333 13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path>
                <path d="M10.8333 13V9.24738L14.0833 11.1237L17.3333 13L14.0833 14.8764L10.8333 16.7527V13Z" fill="currentColor" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5"></path>
                <path d="M20.25 23.5V20.25M20.25 20.25V17M20.25 20.25H17M20.25 20.25H23.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeOpacity="0.75" strokeWidth="2.5"></path>
            </mask>
            <g mask="url(#mask0_281_82)">
                <path d="M0 0H26V26H0V0Z" fill="currentColor"></path>
            </g>
        </svg>
    )
}

export default ImportSound